'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var delayReady = false;

var reset = function reset(parentNode) {
	var img = parentNode.querySelector('.InlineZoom-image');
	var zoom = parentNode.querySelector('.InlineZoom-zoomed');

	parentNode.classList.remove('InlineZoom--active');

	img.style.visibility = 'visible';
	zoom.style.visibility = 'hidden';
	delayReady = false;
};

var mouseMove = function mouseMove(_ref) {
	var parentNode = _ref.parentNode;
	return function (e) {
		if (!delayReady) {
			return;
		}

		var img = parentNode.querySelector('.InlineZoom-zoomed');
		var multiWidth = (img.offsetWidth - parentNode.offsetWidth) / parentNode.offsetWidth;
		var multiHeight = (img.offsetHeight - parentNode.offsetHeight) / parentNode.offsetHeight;
		var x = e.clientX - parentNode.getBoundingClientRect().left;
		var y = e.clientY - parentNode.getBoundingClientRect().top;

		img.style.left = '-' + x * multiWidth + 'px';
		img.style.top = '-' + y * multiHeight + 'px';
	};
};

var prepareZoom = function prepareZoom(parentNode) {
	var img = parentNode.querySelector('.InlineZoom-image');
	var zoom = parentNode.querySelector('.InlineZoom-zoomed');

	parentNode.classList.add('InlineZoom--active');

	zoom.style.position = 'absolute';
	zoom.style.maxWidth = 'none';

	if (!zoom.src) {
		zoom.addEventListener('load', function () {
			img.style.visibility = 'hidden';
			zoom.style.visibility = 'visible';
		}, { once: true });

		zoom.src = zoom.dataset.src;
		return;
	}

	img.style.visibility = 'hidden';
	zoom.style.visibility = 'visible';
};

var mouseEnter = function mouseEnter(_ref2, delay) {
	var parentNode = _ref2.parentNode;
	return function (e) {
		setTimeout(function () {
			if (e.target !== document.querySelector('.InlineZoom-listener:hover')) {
				return;
			}

			prepareZoom(parentNode);
			delayReady = true;
		}, delay);
	};
};

var mouseLeave = function mouseLeave(_ref3) {
	var parentNode = _ref3.parentNode;
	return function () {
		return reset(parentNode);
	};
};

exports.default = function (el, delay) {
	el.parentNode.addEventListener('mouseenter', mouseEnter(el, delay));
	el.parentNode.addEventListener('mouseleave', mouseLeave(el));
	el.parentNode.addEventListener('mousemove', mouseMove(el));
};